import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Firmantes } from '../models/firmantes';
import { TipoDocumento } from '../../documentos/models/tipo-documento';
import { TipoEnvio, TipoEnvioClass } from '../models/tipo-envio';
import { DatosEnviosService } from './datos-envios.service';
import { validacionBody, validacionNombre, validacionTipoDocs } from './customValidators';
import { TipoMail } from '../models/tipo-mail';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatosFirmaService } from 'src/app/pages/panelControl/services/datos-firma.service';

@Injectable({
  providedIn: 'root'
})
export class FormularioEnvioService {

  public formularioEnvio: FormGroup = new FormGroup({});
  firmante = {} as Firmantes;
  envio!: TipoEnvio
  disableRecordatorio: boolean = true;
  documento = {} as TipoDocumento;
  objetoEnvio: any;
  enviosFiltrados: TipoEnvio[] = [];
  recordatorios: number[] = [null];
  firmantesInit: Firmantes[] = [
    {
      orden:1,
      tipoFirmante:{
        codigo:"100",
        desc:"Firmante principal"
        },
      tipoDestinatario:{
        codigo:"",
        desc:""
      },
      tipoBusqueda:{
        codigo:"",
        desc:""
      }
    }
  ]
  documentosArrayInit: TipoDocumento[] =[
    {
      cifOrden: null,
      cifPage: null,
      fusionable: false,
      generico: false,
      idTipoDocumento: null,
      nombre: '',
      ordenFusion: null,
      texto: '',
      textoAExcluir: '',
      paginas: null,
      estado: "Incompleto",
      idTipoDocOrigen: null,
      incluirContenido: false,
      tiposContenido: [],
      firmantesNif: [],
      idPdf:'',
      esCopiaBasica:false,
      split:'',
      formatoNombreArchivoAuditTrail:'',
      formatoNombreArchivoFirmado:'',
      esRLT:false
    }
  ]

  formEnvioTemporal: FormGroup = new FormGroup({});
  tiposMails: TipoMail[]=[];

  mailRefreshKey = 0;
  smsRefreshKey = 0;
  otpRefreshKey = 0;

  desplegablesFiltros: any;


constructor(public fb: FormBuilder,
            private datosEnvioService: DatosEnviosService,
            private _snackBar: MatSnackBar,
            public datosFirmaService: DatosFirmaService) {
              this.montarFormularioVacio();
              // this.getTipoMail();
}

montarFormularioVacio(){
  let formArrayEnvioInit = this.setExistingFirmantes(this.firmantesInit)
  this.formularioEnvio = this.fb.group({
    activo: false,
    idV3TipoEnvio: [''],
    idTipoEnvio: [''],
    nombre: [''],
    firmantes: formArrayEnvioInit,
    subject:[''],
    body: [''],
    bodySMS: [''],
    tiposDocumento: this.fb.array([]),
    recordatorio: [false],
    reminders_String: [null],
    envioMasivo: [false],
    esRLT: [false],
    envioMail:[true],
    ordenMail:[''],
    envioSMS: [false],
    ordenTelefonoSMS:[''],
    securizadoSMS: [false],
    ordenTelefonoOTP:[''],
    envioXml:[false],
    nombreComienzaLibra:[{ value: '', disabled: true }],
    envioParalelo:[false],
    canalEnvioActivo:[''],
    caducidad:[365]
  })
}

//al cargar el formulario miramos si es un formulario de tipo de envío nuevo con id=0 o una modificación de tipo de envío
async inicializaFormulario(envio: TipoEnvio){
    // await this.getTipoEnvios();
    await this.getDesplegables();
    await this.getTipoMail();
    this.envio = envio;
    let formArrayEnvio = this.setExistingFirmantes(envio.firmantes);
    this.isReadOnly();
    if(envio.idTipoEnvio == ""){
      this.formularioEnvio = this.fb.group({
        activo: false,
        idV3TipoEnvio:[''],
        idTipoEnvio:[''],
        nombre: ['', [validacionNombre(this.desplegablesFiltros.Dosieres, envio), Validators.pattern(/^[^'"/\\]*$/), Validators.maxLength(250)]],
        // nombre: ['', [validacionNombre(this.enviosFiltrados, envio), Validators.pattern(/^[^'"/\\]*$/), Validators.maxLength(250)]],
        firmantes: formArrayEnvio,
        subject:[''],
        body: [''],
        bodySMS: ['', validacionBody(()=>this.formularioEnvio)],
        tiposDocumento: this.fb.array([], validacionTipoDocs(this.envio)),
        recordatorio: [false],
        reminders_String: [null],
        envioMasivo: [false],
        esRLT: [false],
        envioMail:[true],
        ordenMail: ['', Validators.required],
        envioSMS: [false],
        ordenTelefonoSMS:['', Validators.required],
        securizadoSMS: [false],
        ordenTelefonoOTP:['', Validators.required],
        envioXml:[false],
        nombreComienzaLibra:[{ value: '', disabled: true }, Validators.required],
        envioParalelo:[false],
        canalEnvioActivo:['MAIL'],
        caducidad:[365, [Validators.required, Validators.min(1), Validators.max(365)]]
      })
    }else{
      let formArrayDocumento = this.setExistingDocumentos(envio.tiposDocumento)
      this.formularioEnvio = this.fb.group({
        activo:[envio.activo],
        idV3TipoEnvio:[envio.idV3TipoEnvio],
        idTipoEnvio:[envio.idTipoEnvio],
        nombre: [envio.nombre, [validacionNombre(this.desplegablesFiltros.Dosieres, envio), Validators.pattern(/^[^'"/\\]*$/), Validators.maxLength(250)]],
        firmantes: formArrayEnvio,
        subject: [envio.subject],
        body: [envio.body],
        bodySMS: [envio.bodySMS, validacionBody(()=>this.formularioEnvio)],
        tiposDocumento: formArrayDocumento,
        recordatorio: [envio.recordatorio],
        reminders_String: [envio.reminders_String],
        envioMasivo:[envio.envioMasivo],
        estado: [envio.estado],
        esRLT:[envio.esRLT],
        envioMail:[envio.envioMail],
        ordenMail:[envio.ordenMail?.codigo, Validators.required],
        envioSMS: [envio.envioSMS],
        ordenTelefonoSMS:[envio.ordenTelefonoSMS?.codigo, Validators.required],
        securizadoSMS: [envio.securizadoSMS],
        ordenTelefonoOTP:[envio.ordenTelefonoOTP?.codigo, Validators.required],
        envioXml:[this.checkSiXml(envio)],
        nombreComienzaLibra:[envio.nombreComienzaLibra, Validators.required],
        envioParalelo:[envio.envioParalelo],
        canalEnvioActivo:[envio.canalEnvioActivo ? envio.canalEnvioActivo : 'MAIL'],
        caducidad:[envio.caducidad, [Validators.required, Validators.min(1), Validators.max(365)]]
      })
      if (envio.reminders_String?.length>0) this.disableRecordatorio=false;
      this.envioAEditar = {...this.formularioEnvio.value};
      this.envioAEditar.ordenMail = this.buscarModoEnvioDescripcion('ordenMail');
      this.envioAEditar.ordenTelefonoSMS = this.buscarModoEnvioDescripcion('ordenTelefonoSMS');
      this.envioAEditar.ordenTelefonoOTP = this.buscarModoEnvioDescripcion('ordenTelefonoOTP');
    }
    this.getAvisos(); //montamos el array de avisos de firma
    this.subscribeToEnvioParalelo();
  }

  //hacemos los campos asociados readOnly si los defectos y los ajustes están o no clicados
  isReadOnly(){
    this.envio.recordatorio == true ? this.disableRecordatorio = false : this.disableRecordatorio = true ;
  }

  //getters de los campos del formulario
  get firmantes(){ return this.formularioEnvio.get('firmantes') as FormArray }
  get tiposDocumento(){ return this.formularioEnvio.get('tiposDocumento') as FormArray }
  get recordatorio(){ return this.formularioEnvio.get('recordatorio').value }
  get reminders_String(){ return this.formularioEnvio.get('reminders_String').value}
  get securizadoSMS(){ return this.formularioEnvio.get('securizadoSMS') }
  get envioMail(){ return this.formularioEnvio.get('envioMail') }
  get canalEnvioActivo(){ return this.formularioEnvio.get('canalEnvioActivo') }
  get ordenMail(){ return this.formularioEnvio.get('ordenMail')}
  get ordenTelefonoSMS(){ return this.formularioEnvio.get('ordenTelefonoSMS')}
  get ordenTelefonoOTP(){ return this.formularioEnvio.get('ordenTelefonoOTP')}
  get envioSMS(){ return this.formularioEnvio.get('envioSMS')}

  //convertimos el firmantesArrayForm en un array de firmantes
  getFirmantes(): Firmantes[]{
    let arrayFirmantes: Firmantes[] = []
    this.firmantes.value.forEach((x: Firmantes) => {
      this.firmante = {
        orden: x.orden,
        tipoFirmante: {codigo: x.tipoFirmante.codigo, desc: x.tipoFirmante.desc},
        tipoDestinatario: {codigo: x.tipoDestinatario.codigo, desc: x.tipoDestinatario.desc},
        tipoBusqueda: {codigo: x.tipoBusqueda.codigo, desc: x.tipoBusqueda.desc}
      }
      arrayFirmantes.push(this.firmante)
    })
    return arrayFirmantes
  }

  //actualizamos un firmante del firmanteArayForm y convertimos el firmantesArrayForm actualizado en un array de Firmantes
  updateFirmantes(firmante: Firmantes){
    this.firmantes.at(firmante.orden-1).setValue(firmante)
    return this.getFirmantes()
  }

  //actualizamos el orden del firmantesArrayForm con el nuevo orden del array totalFirmantes que viene del componente y convertimos el firmantesArrayForm actualizado en un array de Firmantes
  updateOrdenInForm(totalFirmantes: Firmantes[]){
    this.firmantes.setValue(totalFirmantes);
    return this.getFirmantes()
  }

  //añadimos un firmante nuevo y convertimos el firmantesArrayForm actualizado en un array de Firmantes
  addFirmante(firmante: Firmantes){
    const firmanteInForm = this.fb.group({
      orden: [firmante.orden],
      tipoFirmante: this.fb.group({
        codigo:[firmante.tipoFirmante.codigo],
        desc:[firmante.tipoFirmante.desc]
      }),
      tipoDestinatario: this.fb.group({
        codigo:[firmante.tipoDestinatario.codigo],
        desc:[firmante.tipoDestinatario.desc]
      }),
      tipoBusqueda: this.fb.group({
        codigo:[firmante.tipoBusqueda.codigo],
        desc:[firmante.tipoBusqueda.desc]
      })
    })
    this.firmantes.push(firmanteInForm)
    return this.getFirmantes();
  }

  //borramos un firmante con el index, reordenamos los firmantes restantes y convertimos el firmantesArrayForm actualizado en un array de Firmantes
  deleteFirmante(index: number){
    this.firmantes.removeAt(index);
    this.reordenaFirmantes();
    return this.getFirmantes();
  }

  //actualizamos el orden del firmantesArrayForm con los nuevos índices y convertimos el firmantesArrayForm actualizado en un array de Firmantes
  reordenaFirmantes(){
    this.firmantes.value.map((x:Firmantes) => x.orden = this.firmantes.value.indexOf(x)+1)
    this.renameFirmantes(this.firmantes.value)
    return this.getFirmantes();
  }

  renameFirmantes(firmantes: Firmantes[]): Firmantes[] {
    let minCodigo = 103;

    let adicionales = firmantes.filter(x => x.tipoFirmante.desc.includes('Firmante adicional'));

    // ordenamos según código, el '+' los convierte en números en vez de string
    adicionales.sort((a, b) => +a.tipoFirmante.codigo - +b.tipoFirmante.codigo);

    // asignamos los nuevos códigos por orden
    for (let firmante of adicionales) {
      firmante.tipoFirmante.codigo = minCodigo.toString();
      firmante.tipoFirmante.desc = `Firmante adicional ${minCodigo - 102}`; //como el código inicial es 103 le resto 102 al minCodigo para que quede los nombres de los adicionales, 1, 2, 3...
      minCodigo++;
    }
    return firmantes;
  }

  //creamos un nuevo form array con los firmantes que tenemos en el objeto tipo de envío de la api
  setExistingFirmantes(firmantesExistentes: Firmantes[]): FormArray{
    const formArray = new FormArray([]);
    if(firmantesExistentes){
      firmantesExistentes.forEach(x => formArray.push(this.fb.group({
        orden: [x.orden],
        tipoFirmante: this.fb.group({
          codigo:[x.tipoFirmante.codigo],
          desc:[x.tipoFirmante.desc]
        }),
        tipoDestinatario: this.fb.group({
          codigo:[x.tipoDestinatario.codigo],
          desc:[x.tipoDestinatario.desc]
        }),
        tipoBusqueda: this.fb.group({
          codigo:[x.tipoBusqueda.codigo],
          desc:[x.tipoBusqueda.desc]
        })
      })))
    }

    return formArray
  }

  //creamos un nuevo form array con los documentos que tenemos en el objeto tipo de envío de la api
  setExistingDocumentos(documentosExistentes: TipoDocumento[]):FormArray{
    const formArrayDocs = new FormArray([], validacionTipoDocs(this.envio));
    if(documentosExistentes){
      documentosExistentes.forEach(x=> formArrayDocs.push(this.fb.group({
        cifOrden:[x.cifOrden],
        cifPage:[x.cifPage],
        fusionable:[x.fusionable],
        generico:[x.generico],
        idTipoDocumento:[x.idTipoDocumento],
        idTipoDocOrigen: [x.idTipoDocOrigen],
        nombre:[x.nombre],
        ordenFusion:[x.ordenFusion],
        texto:[x.texto],
        textoAExcluir:[x.textoAExcluir],
        paginas:[x.paginas],
        estado:[x.estado],
        firmantesNif: [x.firmantesNif],
        incluirContenido: [x.incluirContenido],
        tiposContenido: [x.tiposContenido],
        idPdf:[x.idPdf],
        esCopiaBasica:[x.esCopiaBasica],
        split:[x.split],
        formatoNombreArchivoAuditTrail:[x.formatoNombreArchivoAuditTrail],
        formatoNombreArchivoFirmado:[x.formatoNombreArchivoFirmado],
        esRLT:[x.esRLT]
      })))
    }
    return formArrayDocs
  }

  //convertimos el tiposDocumento en un array de tipo documento
  getDocumentos(): TipoDocumento[]{
    let arrayDocumentos: TipoDocumento[] = [];
    this.tiposDocumento.value.forEach((x: TipoDocumento) => {
      this.documento = {
        cifOrden: x.cifOrden,
        cifPage: x.cifPage,
        fusionable: x.fusionable,
        generico: x.generico,
        idTipoDocumento: x.idTipoDocumento,
        nombre: x.nombre,
        ordenFusion: x.ordenFusion,
        texto: x.texto,
        textoAExcluir: x.textoAExcluir,
        paginas: x.paginas,
        estado: x.estado,
        idTipoDocOrigen: x.idTipoDocOrigen,
        incluirContenido: x.incluirContenido,
        tiposContenido: x.tiposContenido,
        firmantesNif: x.firmantesNif,
        idPdf: x.idPdf,
        esCopiaBasica: x.esCopiaBasica,
        split: x.split,
        formatoNombreArchivoAuditTrail: x.formatoNombreArchivoAuditTrail,
        formatoNombreArchivoFirmado: x.formatoNombreArchivoFirmado,
        esRLT: x.esRLT
      }
      arrayDocumentos.push(this.documento)
    })
    return arrayDocumentos
  }

  //borramos un documento a través del idTipoDocumento y convertimos el tiposDocumento actualizado en un array de tipo documento
  deleteDocumento(idTipoDocumento: number){
    let index = this.tiposDocumento.value.findIndex(x => x.idTipoDocumento == idTipoDocumento)
    this.tiposDocumento.removeAt(index);
    return this.getDocumentos();
  }

  //actualizamos el form desde el modal de añadir documentos con la información en pantalla (objetoEnvio)
  actualizaFormulario(objetoEnvio:TipoEnvio){
    this.formularioEnvio.patchValue(objetoEnvio);
    // this.formularioEnvio.setValue(objetoEnvio)
    this.objetoEnvio = this.formularioEnvio.value;
  }

  //añadimos documentos al form y volvemos a actualizar el formulario con los datos en pantalla (objetoEnvio)
  addDocumentosEnForm(documentosExistentes: TipoDocumento[]){
    this.objetoEnvio = this.formularioEnvio.value;
    const ordenMailCodigo = this.obtenerCodigoModoEnvio(this.objetoEnvio.ordenMail);
    const ordenTelefonoSmsCodigo = this.obtenerCodigoModoEnvio(this.objetoEnvio.ordenTelefonoSMS);
    const ordenTelefonoOtpCodigo = this.obtenerCodigoModoEnvio(this.objetoEnvio.ordenTelefonoOTP);
    this.formularioEnvio = this.fb.group({
      activo: [this.objetoEnvio.activo],
      idV3TipoEnvio:[this.objetoEnvio.idV3TipoEnvio],
      idTipoEnvio:[this.objetoEnvio.idTipoEnvio],
      nombre: [this.objetoEnvio.nombre, [validacionNombre(this.desplegablesFiltros.Dosieres, this.objetoEnvio), Validators.pattern(/^[^'"/\\]*$/), Validators.maxLength(250)]],
      firmantes: this.setExistingFirmantes(this.objetoEnvio.firmantes),
      subject: [this.objetoEnvio.subject],
      body: [this.objetoEnvio.body],
      bodySMS: [this.objetoEnvio.bodySMS, validacionBody(()=>this.formularioEnvio)],
      tiposDocumento: this.setExistingDocumentos(documentosExistentes),
      recordatorio: [this.objetoEnvio.recordatorio],
      reminders_String: [this.objetoEnvio.reminders_String],
      envioMasivo: [this.objetoEnvio.envioMasivo],
      estado: [this.objetoEnvio.estado],
      esRLT: [this.objetoEnvio.esRLT],
      envioMail:[this.objetoEnvio.envioMail],
      ordenMail:[ordenMailCodigo, Validators.required],
      envioSMS: [this.objetoEnvio.envioSMS],
      securizadoSMS:[this.objetoEnvio.securizadoSMS],
      ordenTelefonoSMS:[ordenTelefonoSmsCodigo, Validators.required],
      ordenTelefonoOTP:[ordenTelefonoOtpCodigo, Validators.required],
      envioXml:[this.objetoEnvio.envioXml],
      nombreComienzaLibra:[{value: this.objetoEnvio.nombreComienzaLibra, disabled: this.isDiabledNombreComienzaLibra()}, Validators.required],
      envioParalelo:[this.objetoEnvio.envioParalelo],
      canalEnvioActivo:[this.objetoEnvio.canalEnvioActivo ? this.objetoEnvio.canalEnvioActivo : 'MAIL'],
      caducidad:[this.objetoEnvio.caducidad, [Validators.required, Validators.min(1), Validators.max(365)]]
    })
    this.habilitarModoEnvio();
    this.subscribeToEnvioMailValue();
    this.subscribeToEnvioSMSValue();
    this.subscribeToEnvioXmlValue();
    this.subscribeToEnvioParalelo();
  }

  private obtenerCodigoModoEnvio(valor: any): any {
    if (valor === null || valor === undefined) return '';
    if (typeof valor === 'object') return valor.codigo ?? '';
    return valor;
  }

  //actualizamos el orden del tiposDocumento con el nuevo orden del array totalDocs que viene del componente y convertimos el firmantesArrayForm actualizado en un array de Firmantes
  updateOrdenDocsInForm(totalDocs: TipoDocumento[]){
    this.tiposDocumento.setValue(totalDocs);
    return this.getDocumentos()
  }

  //llamamos el array de tipo de envío para poder hacer la validación de nombre de envío duplicado
  async getTipoEnvios(){
    if(this.enviosFiltrados.length === 0){
      await this.datosEnvioService.getTipoEnvios([],0)
      this.enviosFiltrados = this.datosEnvioService.enviosFiltrados
    }else this.enviosFiltrados = this.datosEnvioService.enviosFiltrados
  }

  async getDesplegables(): Promise<void>{
    // Ensure desplegablesFiltros is loaded from DatosFirmaService before using it
    return new Promise((resolve) => {
      this.datosFirmaService.getDesplegablesFiltros().subscribe(
        () => {
          this.desplegablesFiltros = this.datosFirmaService.desplegablesFiltros;
          resolve();
        },
        error => {
          if(error.status!==401) {
            this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
          }
          // Even on error, resolve so inicializaFormulario can continue safely
          resolve();
        }
      );
    });
  }

  totalDocsFusion: TipoDocumento[] = [];
  totalDocsNoFusion: TipoDocumento[] = [];
  totalDocumentos: TipoDocumento[] = [];

  documentosFusionables(){
    this.totalDocsFusion = this.getDocumentos().filter(x => x.fusionable)
    this.totalDocsNoFusion = this.getDocumentos().filter(x => !x.fusionable)
    this.reordenarFusion();
  }

  reordenarFusion(){
    this.totalDocsFusion.map(x => x.ordenFusion = this.totalDocsFusion.indexOf(x)+1);
  }

  marcarFusionables(){
    this.totalDocsFusion.map(x => x.fusionable = true);
    this.totalDocsNoFusion.map(x => {
      x.fusionable = false;
      x.ordenFusion = null;
    });
  }

  //juntamos los docs fusionables y los no fusionables en el totalDocumentos array
  juntarDocs(){
    this.totalDocumentos = this.totalDocsFusion.concat(this.totalDocsNoFusion)
    this.updateOrdenDocsInForm(this.totalDocumentos)
  }

  //gestionado desde el servicio para que dispare la función después de iniciar el formulario de envíos.
  getAvisos(){
    this.recordatorios = [null];
    if(this.reminders_String !== null && this.reminders_String !== undefined){
      let recordatoriosArray = this.reminders_String.split(',');
      this.recordatorios = recordatoriosArray.map((x:string)=> Number(x));
      if(this.recordatorios.length > 0 && this.recordatorios[0]!==0) this.formularioEnvio.controls['recordatorio'].setValue(true);
    }

  }

  async resetFormularioEnvio(){
    let envioInicio = {} as TipoEnvio;
    envioInicio.idTipoEnvio = "";
    await this.inicializaFormulario(envioInicio);
  }

  async recuperaFormularioTemporal(envio: TipoEnvio){
    const isEmpty = Object.keys(this.formEnvioTemporal.value).length;
    if(isEmpty > 0) {
      this.formularioEnvio = this.formEnvioTemporal;
      this.getAvisos()
    }
    else await this.inicializaFormulario(envio)
  }

  addFormularioTemporal(){
    this.formEnvioTemporal = this.formularioEnvio;
  }

  envioAEditar:any = new TipoEnvioClass();

  hayCambiosDosier():boolean{
    let objetoFinal = this.formularioEnvio.value;
    objetoFinal.ordenMail = this.buscarModoEnvioDescripcion('envioMail');
    objetoFinal.ordenTelefonoSMS = this.buscarModoEnvioDescripcion('ordenTelefonoSMS');
    objetoFinal.ordenTelefonoOTP = this.buscarModoEnvioDescripcion('ordenTelefonoOTP');
    if(JSON.stringify(this.envioAEditar) === JSON.stringify(objetoFinal)){
      return false;
    }else{
      return true
    }
  }

  buscarModoEnvioDescripcion(modoEnvio:string):TipoMail{
    let modoEnvioObject: TipoMail = {codigo:'', desc:''}
    this.tiposMails.forEach(x => {
      if(x.codigo == this.formularioEnvio.controls[modoEnvio].value){
        modoEnvioObject = {codigo: x.codigo,desc: x.desc}
      }
    })
    return modoEnvioObject
  }

  async getTipoMail(): Promise<void>{
    return new Promise((resolve) => {
      this.datosEnvioService.getTipoMail().subscribe(
        next => {
          this.tiposMails = next;
          resolve();
        },
        error => {
          if(error.status!==401) {
            this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
          }
          resolve(); // resolve even on error so await doesn't hang
        }
      )
    });
  }

  habilitarModoEnvio(){
    if(this.envioMail.value){
      this.ordenMail.enable();
    }
    if(!this.envioMail.value){
      this.ordenMail.setValue('');
      this.ordenMail.disable();
      this.mailRefreshKey++;
      this.ordenTelefonoOTP.setValue('');
      this.ordenTelefonoOTP.disable();
      this.otpRefreshKey++;
      this.securizadoSMS.setValue(false);
    }
    if(this.envioSMS.value){
      this.ordenTelefonoSMS.enable();
    }
    if(!this.envioSMS.value){
      this.ordenTelefonoSMS.setValue('');
      this.ordenTelefonoSMS.disable();
      this.smsRefreshKey++;
    }
    if(!this.securizadoSMS.value) this.ordenTelefonoOTP.disable();
  }

  subscribeToEnvioMailValue(){
    this.envioMail.valueChanges.subscribe(value => {
      this.habilitarModoEnvio();
    });
  }

  subscribeToEnvioSMSValue(){
    this.envioSMS.valueChanges.subscribe(value => {
      this.habilitarModoEnvio();
    });
  }

  checkSiXml(envio: TipoEnvio):boolean{
    if(envio.nombreComienzaLibra!==undefined && envio.nombreComienzaLibra!=='' && envio.nombreComienzaLibra!==null) return true
    else return false
  }

  isDiabledNombreComienzaLibra():boolean{
    if(this.objetoEnvio.envioXml) return false;
    else return true
  }

  subscribeToEnvioXmlValue() {
    this.formularioEnvio.controls['envioXml'].valueChanges.subscribe((checked) => {
      if (checked) {
        this.formularioEnvio.controls['nombreComienzaLibra'].enable();
      } else {
        this.formularioEnvio.controls['nombreComienzaLibra'].disable();
      }
    });
  }

  ocultarOrden:boolean=false;
  subscribeToEnvioParalelo(){
    this.formularioEnvio.controls['envioParalelo'].valueChanges.subscribe(value => {
      this.ocultarOrden=value;
    })
  }

  getValorFinalCanalEnvioActivo(){
    if(this.envioMail.value && !this.envioSMS.value) this.canalEnvioActivo.setValue('MAIL');
    if(!this.envioMail.value && this.envioSMS.value) this.canalEnvioActivo.setValue('SMS');
  }

  get ordenMailPreSeleccionado(){
    return this.tiposMails.find(x => x.codigo == this.ordenMail.value)?.desc
  }

  get ordenSmsPreSeleccionado(){
    return this.tiposMails.find(x => x.codigo == this.ordenTelefonoSMS.value)?.desc
  }

  get ordenOtpPreSeleccionado(){
    return this.tiposMails.find(x => x.codigo == this.ordenTelefonoOTP.value)?.desc
  }
}
